abstract class ICustomFieldsDAO {
    public abstract getAllCustomFields(eventId: number, accountId: number): Promise<ICustomFieldsDTO[]>;
    public abstract createCustomField(accountId: number, eventId: number, createInput: ICustomFieldsDTO): Promise<void>;
    public abstract updateCustomFields(accountId: number, eventId: number, customFields: ICustomFieldsDTO[]): Promise<ICustomFieldsDTO[]>;
}

interface ICustomFieldFormConfiguration {
    formName: string;
    mandatory: boolean;
    visible: boolean;
    order: number;
}

interface ICustomFieldsDTO {
    default?: boolean;
    label?: string;
    externalFieldId?: string;
    defaultFieldTitle?: string;
    description?: string;
    canBeHidden?: boolean;
    customFieldId?: number;
    defaultFieldId?: number;
    locked?: boolean;
    mandatory?: boolean;
    order?: number;
    type?: string;
    visible?: boolean;
    title?: string;
    field?: ICustomFieldsDTO;
    group?: ICustomFieldsDTO[];
    fields?: ICustomFieldsDTO[];
    optionsList?: string[];
    canBeOptional?: boolean;
    isCollapsed?: boolean;
    triaged: boolean;
    configurations: ICustomFieldFormConfiguration[];
}

export enum TriageQuestionTypeValue {
    ATTENDANCE_METHOD = 'Attendance Method',
    NEW_CUSTOM_FIELD = 'New Custom Field'
}

export {
    ICustomFieldsDAO,
    ICustomFieldsDTO,
    ICustomFieldFormConfiguration
};
